import { Transform } from 'class-transformer';
import { DateTransform } from '@/utils/value-transformers/date.transform';

export default class ClientNoteModel {
  id!: number;

  observacao!: string;

  flagDestaque!: number;

  @Transform(DateTransform)
  createdAt!: Date;

  createdByUserId!: number | null;

  createdByUserName!: string | null;
}
